import React, { useState } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import OrderSection from "../../update_pharmacy_customer/components/order/components/create_order/OrderSection";
import { COLORS } from "../styles/theme";
import DataAccordion from "./DataAccordion";

interface IProps {
  title: string;
  readyHint: string;
  personId?: string;
  prescriptionId?: string;
  response?: any;
  onOrdered?: (response: any) => void;
}

/** Creates an order for an approved prescription and shows the order response. */
const CreateOrderPanel: React.FC<IProps> = ({ title, readyHint, personId, prescriptionId, response, onOrdered }) => {
  const [orderResponse, setOrderResponse] = useState<any>(response ?? null);

  if (orderResponse) {
    return <DataAccordion title={title} data={orderResponse} defaultExpanded />;
  }

  return (
    <Grid item xs={12} style={{ width: "100%", maxWidth: 1200 }}>
      <Paper style={{ padding: 24, backgroundColor: "#fff3e0" }}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <div style={{ marginBottom: 16 }}>
          <Alert severity="warning">{readyHint}</Alert>
        </div>
        <OrderSection
          initialPersonId={personId}
          initialPrescriptionId={prescriptionId}
          submitColor={COLORS.orange}
          onSuccess={(created: any) => {
            setOrderResponse(created);
            onOrdered?.(created);
          }}
        />
      </Paper>
    </Grid>
  );
};

export default CreateOrderPanel;
